import { PropsWithChildren } from 'react';
import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { cn } from '@shared/utils/helpers';

type LabelProps = PropsWithChildren<
  PropsWithClassName<{
    htmlFor?: string;
    required?: boolean;
    error?: string;
  }>
>;

export function Label({ htmlFor, error, required, className, children }: LabelProps) {
  return (
    <label htmlFor={htmlFor} className={cn('mb-0 font-normal', { 'text-red-600': error }, className)}>
      {children}
      {required && (
        <span className="ml-1 text-indigo-500" title="Required">
          *
        </span>
      )}
    </label>
  );
}
